import styled, { css } from 'styled-components';
import { ifProp, theme } from 'styled-tools';
import media from 'themes/media';
import { Link } from 'react-router-dom';

const NavbarIcon = styled.div`
  font-size: 18px;
  width: 20px;
  display: flex;
  color: #00a4af;
`;

const NavbarItem = styled(Link)`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  color: ${(props) =>
    props.active
      ? props.theme.colors.text.textColorDark
      : props.theme.colors.text.textColor};
  background: ${(props) =>
    props.active ? props.theme.colors.background.menuHover : 'transparent'};
  width: 80px;
  height: 60px;
  margin: 6px auto;
  border-radius: 10px;
  :hover {
    ${NavbarIcon} {
      color: white;
    }
    background-color: #00a4af;
  }

  ${ifProp(
    'active',
    css`
      ${NavbarIcon} {
        color: white;
      }
    `
  )};

  @media (min-width: 1400px) and (max-height: 778px) {
    padding: 3px ${(props) => props.theme.sizing.menuPadding};
  }

  ${media.lessThan('tablet')`
    padding: 9px ${(props) => props.theme.sizing.menuPadding};
  `};

  @media (max-width: 375px) {
    padding: 7px ${(props) => props.theme.sizing.menuPadding};
  }

  @media (max-height: 740px) and (max-width: 1400px) {
    padding: 6px ${(props) => props.theme.sizing.menuPadding};
  }
`;

const NavbarText = styled.span`
  font-size: ${theme('sizing.text3')};
  line-height: 14px;
  margin-top: 10px;
  font-weight: 400;
  text-transform: uppercase;
  color: ${theme('colors.text.textColor')};
  text-align: center;
`;

const SiteNavbarDivider = styled.div`
  margin: 16px auto 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.text.white15};
  width: 60px;
`;

const Navbar = styled.div`
  background: ${(props) => props.theme.colors.background.menuBodyColor};
  padding-top: 10px;
`;

const SwitchAccountHeading = styled.p`
  width: 90%;
  padding: 6px 30px;
  line-height: 1;
  font-weight: 400;
`;

const Body = styled.div`
  flex-direction: column;
  z-index: 990;
  top: ${(props) => props.theme.sizing.menuHeight};
  right: 0;
  border-bottom: 1px solid
    ${(props) => props.theme.colors.background.borderColor};
  transition: all 0.3s linear;
  background: ${(props) => props.theme.colors.background.menuBodyColor};
  position: static;
  transform: none;
  border-bottom: none;
  flex-grow: 1;
  width: auto;

  display: none;
  ${media.greaterThan('desktop')`
    display: flex;
  `}
`;

const LanguageSwitcherContainer = styled.div`
  display: none;
  ${media.greaterThan('desktop')`
    display: block;
  `}
  padding: 24px 0 16px;
  margin-left: 30px;
  margin-right: 30px;
  border-top: 1px solid #e8ebf2;
`;

const RealDemo = styled.div`
  position: relative;
  font-size: 18px;
  cursor: pointer;
  font-weight: ${ifProp('active', 'bold', '500')};
  transition: all 0.2s ease-in-out;
  color: ${({ active, demo }) =>
    demo ? theme('colors.background.primaryColor') : theme('utils.accent')};
`;

const SwitchAccountTypeWrapper = styled.div`
  margin-top: 57px;
`;

const LogoutContainer = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  background: #003765;
  color: #ffffff;
  font-size: 10px;
  line-height: 14px;
  width: 60px;
  border-radius: 40px;
  padding: 8px 11.5px;
  margin: 20px auto 0;
  text-transform: uppercase;
  border: 1px solid transparent;

  &:hover {
    background: #001947;
    border: 1px solid #003765;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: transparent;
  max-height: 100%;
  top: 0;
  right: 0;
  z-index: 999;
  left: 0;

  ${media.greaterThan('desktop')`
    position: sticky;
    width: ${(props) => props.theme.sizing.menuWidth};
    flex-shrink:0;
    min-height: 100vh;
    border-right: none;
  `}
`;

export const S = {
  NavbarIcon,
  NavbarText,
  SiteNavbarDivider,
  Navbar,
  SwitchAccountHeading,
  LanguageSwitcherContainer,
  RealDemo,
  SwitchAccountTypeWrapper,
  Body,
  Container,
  NavbarItem,
  LogoutContainer,
};
